import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { KbDataExtractionRequestService } from 'src/app/services/feature/data-extraction-request/kb-data-extraction-request.service';

@Component({
  selector: 'app-kb-vehicle-information',
  templateUrl: './kb-vehicle-information.component.html',
  styleUrl: './kb-vehicle-information.component.scss',
  standalone: false
})
export class KbVehicleInformationComponent implements OnInit, OnDestroy {

  private dataExtractionService = inject(KbDataExtractionRequestService);
  private fb = inject(FormBuilder);
  subscription = new Subscription();
  vehicleMakes: any;
  vehicleModels: any;
  submitted: boolean = false;
  vehicleInformationForm = this.fb.group({
    vehicleIdentificationNumber: ['', Validators.required],
    vehicleYear: ['', Validators.required],
    vehicleMake: ['', Validators.required],
    vehicleModel: ['', Validators.required],
    vehicleTruckNumber: ['', Validators.required],
    vehicleMileage: [''],
  });

  constructor(
  ) {

  }

  async ngOnInit(): Promise<void> {
    await this.getVehicleDetails();
    this.subscription.add(this.dataExtractionService.vehicleInformationData$
      .subscribe(vehicleInformationData => {
        this.vehicleInformationForm.patchValue({ ...vehicleInformationData });
      }));
  }

  getVehicleDetails(): void {
    this.subscription.add(this.dataExtractionService.getVehicleDetails().subscribe((response: any) => {
      this.vehicleMakes = response.vehicleMakeList;
      this.vehicleModels = response.vehicleModelList;
    }));
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  back() {
    this.dataExtractionService.currentComponent$.next('reportECURecipient');
  }
  next() {
    this.submitted = true;
    this.dataExtractionService.setvehicleInformationData(this.vehicleInformationForm.value);
    this.dataExtractionService.currentComponent$.next('eCUInformation');
  }
}
